import { requester } from "App";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";


function PaymentHistoryGateway() {
    const location = useLocation();
    const navigate = useNavigate();
    const [isMounted, setMounted] = useState(false);
    const [data, setData] = useState();
    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            const queryParams = new URLSearchParams(location.search);
            const idParams = queryParams.get('id');
            setData({
                id: idParams
                
            });
        }
    }, [isMounted])
    useEffect(() => {
        if (data)
            requester.findByPaymentHistory(data, (result) => {
                let res = result.data;
                if(result.code === 0){
                    navigate(`/ws/${res.storeCode}/landingGateWay?${res.machineData}&trxId=${res.trxId}&trackId=${res.trackId}&amount=${res.amount}&storeCode=${res.storeCode}&deviceCode=${res.deviceCode}`)
                }
            })
    }, [data]);
    return (
        <Container>

        </Container>
    );
}

export default PaymentHistoryGateway;
